module.exports = __webpack_public_path__ + "img/edge_step_3.9f7dc662.png";